import * as React from 'react';
import { DefaultButton, Dialog, DialogFooter, DialogType, PrimaryButton } from '@fluentui/react';

interface ConfirmMessageProps {
    title: string;
    message?: string;
    content?: JSX.Element;
    minWidth?: string | number;
    onCancel?: () => void;
    onConfirm: () => void;
    cancelText?: string | null;
    confirmText?: string;
    cancelDisabled?: boolean;
    confirmDisabled?: boolean;
}

export const ConfirmMessage: React.FC<ConfirmMessageProps> = ({
    title,
    message,
    onCancel = () => {},
    onConfirm,
    content,
    minWidth,
    cancelText = 'Nein',
    confirmText = 'Ja',
    cancelDisabled = false,
    confirmDisabled = false,
}) => {
    return (
        <Dialog
            hidden={false}
            minWidth={minWidth}
            dialogContentProps={{
                title,
                subText: message,
                type: DialogType.normal,
            }}
        >
            {content}
            <DialogFooter>
                {cancelText != null && <DefaultButton onClick={onCancel} text={cancelText} disabled={cancelDisabled} />}
                <PrimaryButton onClick={onConfirm} text={confirmText} disabled={confirmDisabled} />
            </DialogFooter>
        </Dialog>
    );
};
